<template>
	<div class="page-about">
		<section class="container">
			<div class="row justify-content-center">
				<div class="col-md-8 text-center">
				<h2>Solutions</h2>
					<p class="lead pr-md-35">Our company consists of a team of driven founders with extensive submarine experience.
					We build disruptive solutions to address challenges faced in the maritime domain</p>
				</div>
			</div>
		</section>
	</div>	
</template>

<script>
export default {
	name: 'About',
	components: {

	}
}
</script>
